import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  background-color: #f8f9fd;
  flex-direction: column;
  height: 100vh;
  position: relative;
  flex: 1;
  
`;

export const SelectSection = styled.section`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 1rem;
  position: relative;
  max-height: calc(100vh - 2rem - 90px);
`;

export const HeaderCardAllCustomer = styled.p`
  color: #123559;
  margin: 0;
  font-family: "Prompt";
  font-size: 22px;
  font-weight: bold;
  text-align: center;
`;

export const CircleNumber = styled.div`
  display: flex;
  background-color: #ffffff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
`;

export const HeaderDivCardAllCustomer = styled.div`
  display: flex;
  width: 450px;
  margin-bottom: 0.5rem;
  padding: 0rem 1rem;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerCustomer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardAllCustomer = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: scroll !important;
  margin-right: 0.25rem;
  padding-left: 0.5rem;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ContainerCard = styled.section`
  flex: 1;
  ${(props: { flexdisplay: boolean }) =>
    props.flexdisplay ? "display: flex;" : "display:none;"}
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 1rem;
  box-shadow: 0px 0px 6px 6px rgba(128, 128, 128, 0.1);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  max-height: fit-content;
`;

export const MainContainerCard = styled.section`
  display: flex;
  flex: 1;
  max-width: 30rem;
  padding: 1rem;
`;
